import { type CustomTooltipProps } from "ag-grid-react"

import { StatusColor } from "~/constants/status"
import HeaderTooltip from "./HeaderTooltip"
import TooltipMessageCard from "./TooltipMessageCard"

export type RunDriftTooltipValue = {
  tooltipType: "RunDrift"
  ranOn: string
  sentences: string[]
}

export default function RunDriftTooltip(props: CustomTooltipProps) {
  if (props.location === "header") return <HeaderTooltip {...props} />
  const value = props.value as RunDriftTooltipValue | undefined
  if (!value) return null
  return (
    <TooltipMessageCard
      badge={{ text: "Changed since the suggestion", color: StatusColor.Warning }}
    >
      {[
        `Suggested on ${value.ranOn}.`,
        ...value.sentences,
        "The next suggested qty run will update it.",
      ].join("\n")}
    </TooltipMessageCard>
  )
}
